import { FetchState } from '@/types/fetchState';
import { defineStore } from 'pinia';
import { generateAPI } from '@/shared/lib';
import { StationSimResult, SchemasSystemSimResultDataFromJSON } from '@/generated/src';

export const useResultStore = defineStore('result', {
  state: (): FetchState<StationSimResult> => ({
    data: null,
    loading: false,
    error: null,
  }),

  getters: {
    result: (state): any | null => state.data ?? null,
  },

  actions: {
    /**
     * OpenAPI Generatorは二重配列の場合、keyを適切に変換してくれないので、手動で変換する
     * 二重配列のsimResultsを適切に変換する
     */
    convertSimResults(rawData: any): any {
      if (rawData?.simResults && Array.isArray(rawData.simResults)) {
        const convertedResults = rawData.simResults.map((arr: any[]) => arr.map((item: any) => ({
            ...item,
            qinAll: item.Qin_all || item.qinAll,
            qoutAll: item.Qout_all || item.qoutAll,
            r: item.R || item.r,
            ruika: item.Ruika || item.ruika,
          })));
        return {
          ...rawData,
          simResults: convertedResults,
        };
      }
      return rawData;
    },

    async fetch(basinId: string, stationId: string, tgttime: string, isEn?: boolean) {
      this.loading = true;
      this.error = null;

      try {
        const rawData = await generateAPI().systemApi.resultApiApiResultBasinIdStationIdGet({
          basinId,
          stationId,
          tgttime,
          isEn,
        });
        this.data = this.convertSimResults(rawData);
      } catch (error) {
        this.error = error as Error;
        throw error;
      } finally {
        this.loading = false;
      }
    },
    async fetchOnly(basinId: string, stationId: string, tgttime: string, isEn?: boolean) {
      const rawData = await generateAPI().systemApi.resultApiApiResultBasinIdStationIdGet({
        basinId,
        stationId,
        tgttime,
        isEn,
      });
      return this.convertSimResults(rawData);
    },

    /**
     * データをクリア
     */
    clear() {
      this.data = null;
      this.error = null;
    },
  },
});
